import { StyleFunctionProps } from '@chakra-ui/react';

const AuthenticatedPageWrapper = {
  baseStyle: (props: StyleFunctionProps) => ({
    container: {
      w: 'full',
      p: props.hasBanner ? 0 : { base: '16px', sm: '20px', md: '24px' },
      mx: 'auto',
      maxW: props.hasBanner ? '100%' : '1440px',
      flexDir: 'column',
      flex: '1',
    },
  }),
};

export default AuthenticatedPageWrapper;
